
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
's000d98595e959c1e': `Get It On Google Play`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's100c4928cc74642a': `support the advancement of public health research.`,
's166bd56d19670a72': `Zoom`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's21e73088de6f26f3': `Download on the App Store`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Add a nutrient`,
's475b08749d0706ed': `Help us inform millions of consumers around the world about what they eat`,
's49730f3d5751a433': `Loading...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's547c12ae169d00bc': `Available on F-Droid`,
's59df20feee978e5b': `Error: Invalid value.`,
's5e8250fb85d64c23': `Close`,
's6306a31415aea913': `I SUPPORT`,
's6498dfe4855bb3a7': `unit`,
's6d7b6cdedaadfb6e': `Each donation counts! We appreciate your support in bringing further food transparency in the world.`,
's7124dde792a8faa2': `Android APK`,
's7ce4fd9430e80cea': `value`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
'sb3bdd638a58d30f4': `engage a community of committed citizens,`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd9a0b2293b3cd3c': `Serving size`,
'sc0520e1732a5c568': `Expand image`,
'sc52696641af72b53': `Install the app!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'sd82bc2decefa621b': `remain independent of the food industry,`,
'se206feec7ec57b28': `per 100g`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sfc40ea3d5d5aa6f8': `Your donations fund the day-to-day operations of our non-profit association:`,
's42dd66b2441566fd': `Center icon`,
's422bba9636ce2489': `Center image`,
's8038273de2cf8b73': `Please select a region to crop.`,
's39bcf88721a1e8ee': `Reset selection`,
'sb8178320160f84ea': `Show crop`,
's33f786bb6b4f0cf4': `Crop Result`,
's6cee7cad81dfedd1': `Cropped Image`,
's02ce7a2e7c1b020b': `Validate crop`,
's383ae4449428b61e': `Reset crop`,
'sc6daf8a31883f8b9': `Move image`,
's19059bf0c4f7c162': `Selection area`,
's4f4886341969d552': `Move selection`,
'scfed2f270ef6a3aa': `Select area`,
'sc0cc559e7ede852a': `Resize top`,
's453ab0dbb9b5c777': `Resize right`,
's8a63be30a129a59c': `Resize bottom`,
's787dd11bed0dc88a': `Resize left`,
's8b33c244759d7bd4': `Resize top right`,
'sa63907958bd0ec4b': `Resize top left`,
'sdca5deead576ceee': `Resize bottom right`,
'sac47ea2901d04c15': `Resize bottom left`,
's4df2f533c0c1e7d0': `Image controls`,
'sd1022bc1ef9204f7': `Zoomable image`,
's3f4e4b52f230a892': `Image canvas`,
's5ed03bb1f3a15949': `Picture`,
'scb489a1a173ac3f0': `Yes`,
's09205907b5b56cda': `No`,
's66413c24dcf680e2': `Skip`,
'sab56a1d439576fd6': `Suggestion icon`,
'sf9aee319a006c9b4': `Add`,
'sf44a6b3b232c28ea': str`Replace current value by ${0}`,
'sb3d4f79d9d8b71e5': `Submit`,
's0fb218abc2e157ed': `Invalidate image`,
's8f839a03997a16d7': `View Product`,
's1dc4daf989c71284': `Help us correct the nutritional information`,
's417b90913e05bc17': `Preview`,
's5dd6f12783fca34f': `Edit ingredients list`,
's5666afe5cd0166de': `Please fix the errors or modify the text before confirming`,
's06f6c6f99db6b552': `Original`,
'sc57b630a7a70c61f': `Suggested fix`,
's33f85f24c0f5f008': `Save`,
's2ceb11be2290bb1b': `Cancel`,
's64ef2a6c2dd1d3d1': `Edit`,
'h6bdd1b427aa985a4': html`This tool allows you to correct the ingredients list. You can add, remove or edit
                ingredients list.
                <br>
                This character <span class="highlight">␣</span> represents a space.
                <br>
                This character <span class="highlight">↩︎</span> represents a line break. `,
's11a18a69b30b65ed': `Help us fix errors in ingredients list`,
'sbd6be5cde472f37c': `All insights have been answered! Thanks for your help!`,
'sa95b4224f685a36a': `Close modal`,
'sbad7d2734149470b': `Validate`,
'se419a9ab36987490': `Invalidate`,
's10db5498186c083b': `Cancel crop`,
'sec6377f3c4e9b28c': `I'll propose a better crop`,
's03e9c8114521b998': `I'll edit the ingredients`,
's98ff35f2a00dc60d': `Ingredients :`,
's013bdc8cf0d3583d': `Help us for ingredients`,
'sd1077c055cf9ba6b': `Help us validate the ingredient list of the product.`,
's67ae6594857a4d57': `Thanks for your contribution!`,
's061eb5af92512c85': `Saved! Can you help with another one?`,
'sb125568d43642e6f': `Answer questions about the product.`,
'sdc792b75f1edcaba': `Help us correct the spelling of ingredients.`,
's5c92c0051d44b6de': `Help us correct the nutritional information.`,
'sf57a61152168cc81': `Help us correct the ingredient detection`,
'sd698d21ddecba56b': `Hey! You can help us improve the product information by answering the following parts:`,
's05ec315d9308091a': `Barcode corners icon`,
'scf23a05631f93732': `Confirm Delete`,
'sdcc2555c5dde524f': `Are you sure you want to delete this item? This action cannot be undone.`,
's901ae1e236ac45d3': `Cancel deletion`,
'sc681b137e8f604f7': `Confirm deletion`,
'sdc673e73b5c13aea': `Delete`,
's4f751fb9b3ed766c': `Creating a New Property`,
'sdb97e5976482606e': `Check if a property already exists`,
'sb125227d436c2925': `Search for your property concept in the existing properties database:`,
's86197dcf3e96af64': `Browse and search existing properties`,
's34be4af4e8fec4ae': `Ask the community first`,
's36d86adc823cbfa6': `Before creating a new property, discuss it with the community:`,
's06847c221c4c0bc1': `I would like to create a property to [describe your use case]...`,
'scd21019c3cd618f3': `Join Slack Discussion`,
's8db84aa4bc949af2': `Document the New Property`,
'sb3cbcc1bd0fff140': `Once you've verified that your property doesn't exist and the community agrees it's useful, you need to first document it in the wiki.`,
'sfacbbe968fa7d773': `Property name:`,
's5560fb119e40923d': `Enter property name...`,
's2db7b654c0a9bde0': `Document the property`,
's39e14e14300694c7': `Documentation and Guidelines`,
's801a05fa8e881f37': `Learn more about property creation and guidelines:`,
's3781d25aa51a736c': `Folksonomy Engine Documentation`,
's15d64a0a6715285a': `New key`,
's9b87abd68fb9df45': `Not found? Create new key {value}`,
'scb3b0671d7b7f640': `New value`,
's0d5b7fee0311db68': `Property`,
's41f7dca46d3f1b4a': `Value`,
's8af61807443f32a4': `Actions`,
'seffa8ca49175b5f0': `Personalized properties`,
's907f7a97c6b29425': `Be aware the data model might be modified. Use at your own risk.`,
'hb28f1f2ec1744ee9': html`These properties are created and filed by users for any kind of usages. Feel
                    free to add your own. The properties and values you create
                    <strong>must be factual</strong>. You can dive into
                    <a href="${0}">the list of properties already used by the community</a>
                    or explore the
                    <a href="${1}">properties' documentation and its search engine</a>.`,
'h1fbdfea3ad6d664e': html`This is brought by the
                    <a href="${0}">Folksonomy Engine project</a>. Don't
                    hesitate to participate or give feedback`,
's71a5c9f4b68ef4d4': `Count`,
's57472465a23b41db': `Values`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's74cb3d66f6a668e1': `Documentation`,
's565867d84c04aea2': `Filter properties...`,
's3b430cfa5c1fe7f4': str`Documentation for ${0}`,
's000a5b76bd3a01c2': `Loading properties...`,
's9a7f60fce090ecaf': `Failed to load properties. Please try again later.`,
'scdb6cad0b92721bf': `No properties found.`,
'scace072bef961918': `Rows`,
's0bb2d48532acc455': `Download CSV`,
's255857544a9d5ec0': `Reset`,
'sefaba4adc4ec9219': `Folksonomy Properties`,
'sa548778b24054030': `Explore all contributed properties from the Folksonomy Engine project. These properties provide additional metadata and insights about products in the Open Food Facts database.`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
'sf4cd86a2f5ef2588': `Product Barcode`,
'sbe472dc3c2685985': `Corresponding Value`,
's4d42cc7e00076a3b': `Product Count`,
's1a52515ec8ddade8': `Product barcode`,
'sfe87465d50530725': `Corresponding value`,
's839cc2908a5387f2': `Filter barcodes...`,
'sb7f72e4c8a2d3357': `Filter values...`,
's1205d5f6fccf8e69': `Property Value`,
's58e1eeea7a60ae51': `Loading products...`,
'sb560fa37a7bfb6c2': `No products found for this property.`,
'seea3800e27baa686': `Individual Products`,
's081e2ad82db71e1d': `Grouped Values`,
's9fc41f789c63b40d': `Products`,
's1e00019dc454872d': `Please provide a property name using the property-name attribute.`,
'sc895972c88d38ca5': `Folksonomy property`,
'se5127cf0f92e7e48': `Tip: you can also find the`,
'sb28639570ff3b852': `list of all properties`,
'sdbf806fefc584115': `You should find a`,
's0b4235aae602a950': `dedicated documentation`,
's55d7249883a98ca1': `about this property on Open Food Facts wiki`,
's1e49126af0935a5b': `List of products using this property`,
'sb1c538e038f9b214': str`Very Good Match ${0}%`,
's718dea04853f80ae': str`Good Match ${0}%`,
's300b3a6ee4e1252d': str`Poor Match ${0}%`,
'sc1c08d0cbcc3bd24': `Does Not Match`,
's9c0f52425fd2f07e': `May Not Match`,
'sf88b90b8ba23871c': `Unknown Match`,
'sa1fa766e0d5634d7': `No Score Available`,
    };
  